import { Component } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})

export class CareersComponent {
  careers:any = {};
  fields:any = [
    {label: 'Tech Team', dept: 'tech'},
    {label: 'Sales Team', dept: 'sales'},
    {label: 'Software Implementation & Operations', dept: 'service'},
    {label: 'Supply Chain Operations', dept: 'ops'},
    {label: 'Marketing Team', dept: 'marketing'},
    {label: 'Human Resources', dept: 'hr'},
  ];
  selected_role: any = {};
  constructor() {
    this.careers = {
      tech: [{
          designation: 'Full Stack Developer',
          description: '',
          link: 'https://www.google.com',
          info: ['2+ years experience', 'Delhi NCR', 'JavaScript', 'MySQL']
        }, {
          designation: 'Testing Engineer',
          description: '',
          link: 'https://www.google.com',
          info: ['2+ years experience', 'Delhi NCR']
        }, {
          designation: 'Flutter Developer',
          description: '',
          link: 'https://www.google.com',
          info: ['2+ years experience', 'Delhi NCR']
        }],
      sales: [{
          designation: 'Business Development Manager',
          description: '',
          link: 'https://www.google.com',
          info: ['Full Time', '1+ years experience', 'Delhi NCR']
        }],
      service: [],
      ops: [],
      marketing: [],
      hr: [],
    }
      // {
      //   designation: 'Product Designer',
      //   description: 'A description for a role goes here',
      //   link: 'https://www.google.com',
      //   info: []
      // }, {
      //   designation: 'Product Designer',
      //   description: 'A description for a role goes here',
      //   link: 'https://www.google.com',
      //   info: []
      // }, {
      //   designation: 'Product Designer',
      //   description: 'A description for a role goes here',
      //   link: 'https://www.google.com',
      //   info: []
      // }
  }


  openForm(){
    $('#careers-modal').modal('show');
  }

  selectRole(role){
    this.selected_role = role;
    this.openForm();
  }
}
